const React = require('react');
import classNames from 'classnames';
import Styles from './table-sizer.less';
import appStorage from 'app-settings';

var itemsPerPageOptions = [10, 30, 50, 100];

module.exports = React.createClass({
    propTypes: {
        className: React.PropTypes.string,
        onSizerChange: React.PropTypes.func
    },
    getInitialState() {
        return {
            totalCount: this.props.totalItems
        }
    },
    componentWillMount() {
        this.collection = this.getCollection();
    },
    componentWillReceiveProps(nextProps){
      this.setState({
          totalCount: nextProps.totalItems
      })
    },
    getCollection(){
        return itemsPerPageOptions.map(function(obj){
            return {id: obj, title: obj + ' item(s)'};
        });
    },
    onChange(e, value) {
        this.props.onSizerChange(value);
    },
    getClass() {
        return classNames(Styles.sizer, this.props.className);
    },
    getDefault(){
        return appStorage.getItemsPerPage();
    },
    getComboboxClass(){
        return Styles.combobox
    },
    render: require('./table-sizer.rt')
});



/** WEBPACK FOOTER **
 ** ./src/table/table-sizer/table-sizer.js
 **/